export const SENTRY_BLOCKED_BREADCRUMB_DOMAINS = [
  'cdn-cookieyes.com',
  'cookieyes.com',
  'cdn-cookieyes.com',
  'ct.pinterest.com',
  'directory.cookieyes.com',
  'pagead2.googlesyndication.com',
  'stape.fitfast.com',
  'google.com',
];
